import React from 'react';
import { Layout, SkeletonDisplayText, SkeletonBodyText, SkeletonPage } from '@shopify/polaris';

const LoadingPanel = () => {
    return (
        <SkeletonPage fullWidth>
            <Layout>
                <Layout.Section>
                    <SkeletonDisplayText size="medium" />
                    <SkeletonBodyText lines={2} />
                </Layout.Section>
            </Layout>
        </SkeletonPage>
    );
};

export default LoadingPanel;
